import "../../../../src/content/frontera-streaming/frontera.scss";
import * as React from 'react';
export default {
  React
};